module.exports = {
      id: "rupee-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#rupee",
      toString: function () {
        return this.url;
      }
    }